import { useEffect, useReducer } from 'react';

import useDropdown from './usedropdown';

const ACTION_TYPES = {
  INIT_REQUEST: 'INIT_REQUEST',
  INIT_SUCCESS: 'INIT_SUCCESS',
  INIT_FAILURE: 'INIT_FAILURE',
  BEGIN_WORK_REQUEST: 'BEGIN_WORK_REQUEST',
  BEGIN_WORK_SUCCESS: 'BEGIN_WORK_SUCCESS',
  BEGIN_WORK_FAILURE: 'BEGIN_WORK_FAILURE'
};

const ACTIONS = {
  initRequest: () => ({
    type: ACTION_TYPES.INIT_REQUEST
  }),
  initSuccess: () => ({
    type: ACTION_TYPES.INIT_SUCCESS
  }),
  initFailure: error => ({
    type: ACTION_TYPES.INIT_FAILURE,
    error
  }),
  beginWorkRequest: () => ({
    type: ACTION_TYPES.BEGIN_WORK_REQUEST
  }),
  beginWorkSuccess: () => ({
    type: ACTION_TYPES.BEGIN_WORK_SUCCESS
  }),
  beginWorkFailure: () => ({
    type: ACTION_TYPES.BEGIN_WORK_FAILURE
  })
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.INIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        statusMessage: 'Initializing page'
      };
    }

    case ACTION_TYPES.INIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.INIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.BEGIN_WORK_REQUEST: {
      return {
        ...state,
        isLoading: true,
        statusMessage: 'Searching for encounter'
      };
    }

    case ACTION_TYPES.BEGIN_WORK_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.BEGIN_WORK_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    default: {
      throw Error('useCodingQueueFilterService reducer default should never hit');
    }
  }
};

const initialState = {
  isLoading: false,
  isFailedInit: false,
  statusMessage: ''
};

/* useCodingQueueFilterService Hook. Contains all behavior necessary for
interacting with the service for the Coding Queue Filter screen. */
const useCodingQueueFilterService = service => {
  const [contractsDropdownState, contractsDropdownApi] = useDropdown();
  const [state, dispatch] = useReducer(reducer, initialState);

  const doBeginWork = (contractId, doRedirect) => {
    dispatch(ACTIONS.beginWorkRequest());

    return service.beginWork(contractId)
      .then(result => {
        if (result < 1) {
          alert('No encounters found for contract');
          dispatch(ACTIONS.beginWorkSuccess()); // get rid of the spinner
          return;
        }

        dispatch(ACTIONS.beginWorkSuccess());
        doRedirect(service.serviceRoutes.redirectToDetails(result));
      })
      .catch(e => dispatch(ACTIONS.beginWorkFailure(e.toString())));
  };

  // do the init on first render
  useEffect(() => {
    dispatch(ACTIONS.initRequest());

    service.init()
    .then(result => {
      contractsDropdownApi.setItems(result.contracts);
      dispatch(ACTIONS.initSuccess());
    })
    .catch(e => dispatch(ACTIONS.initFailure(e.toString())));
  }, []);

  const boundActions = {
    setSelectedContract: contractsDropdownApi.setSelectedItem,
    doBeginWork
  };

  return [
    {
      ...state,
      contractsDropdownState
    },
    boundActions
  ];
};

export default useCodingQueueFilterService;
